export default __webpack_public_path__ + "static/media/DemandResponse.14637e06.svg";